/**
 * Created by huangzhangshu on 2018/8/6
 */
import http from '../utils/http';

export async function login(params) {
  console.log(params);
  const { username, password, captcha, indexCodeFlag} = params;
  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);
  formData.append('captcha', captcha);
  formData.append('type', 'account');
  formData.append('flag', indexCodeFlag);

  console.log(captcha);
  return http.postForm('login', formData);
}


export async function fetchLicense() {
  return http.getStatic('static/resources/licInfo.json');
}

export async function fetchSetting() {
  return http.getStatic('static/resources/setting.json');
}

export async function getCodeImg() {
  return http.get('captcha/getCaptcha');
}



// WEBPACK FOOTER //
// ./src/services/login.js